module.exports = "/_next/static/images/bz-e559a5b42c1142863dfd7fbbbd3c67ba.svg";